var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26715 0.798078V15.1986C9.26687 15.9111 8.40552 16.2679 7.90153 15.7643L0.701527 8.56399C0.389231 8.25155 0.389231 7.74513 0.701527 7.4327L7.90153 0.232438C8.39465 -0.260698 9.26715 0.0791495 9.26715 0.798078Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPre);
export default __webpack_public_path__ + "static/media/IconPre.f6ce29d8729536bcd8d99ce712021e6b.svg";
export { ForwardRef as ReactComponent };